import { CircularProgress, Dialog } from '@mui/material';
import { useSelector } from 'react-redux';

import { selectLoader } from '@app/modules/common';

const Loader = () => {
  const { id } = useSelector(selectLoader) ?? {};

  return (
    <Dialog
      open={Boolean(id)}
      PaperProps={{
        style: {
          backgroundColor: 'transparent',
          overflow: 'hidden',
          width: '30vw',
          height: '30vh',
          justifyContent: 'center',
          alignItems: 'center',
          boxShadow: 'none',
        },
      }}
      BackdropProps={{
        style: {
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
        },
      }}
    >
      <CircularProgress size={50} thickness={2} />
    </Dialog>
  );
};

export { Loader };
